import { render, staticRenderFns } from "./UserTaskRulesConfig.vue?vue&type=template&id=2dbb4c84&scoped=true"
import script from "./UserTaskRulesConfig.vue?vue&type=script&lang=js"
export * from "./UserTaskRulesConfig.vue?vue&type=script&lang=js"
import style0 from "./UserTaskRulesConfig.vue?vue&type=style&index=0&id=2dbb4c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb4c84",
  null
  
)

export default component.exports